<script setup>
import BaseModal from "@/components/global-themed/BaseModal.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import DefaultInput from "@/components/global-themed/inputs/DefaultInput.vue";
import DefaultTextarea from "@/components/global-themed/inputs/DefaultTextarea.vue";
import CustomToggle from "@/components/global-themed/inputs/CustomToggle.vue";

import {useApiChangeLogs} from "@/composables/admin/useApiChangeLogs";

const {
  showModal,
  modalTitle,
  modalDescription,
  modalBreakingChange,
  editApiChangeLog,
  closeEditModal
} = useApiChangeLogs();

const {mutate, isPending} = editApiChangeLog();
</script>

<template>
  <Teleport
    v-if="showModal"
    to=".tailwind"
  >
    <BaseModal
      @close="closeEditModal"
    >
      <ModalContentWrapper>
        <ModalHeader>
          <ModalHeading>Edit and Approve API Change Log</ModalHeading>
        </ModalHeader>
        <div class="tw-flex tw-flex-col tw-gap-6">
          <DefaultInput
            id="title"
            v-model="modalTitle"
            type="title"
            label="Title"
          />

          <DefaultTextarea
            id="description"
            v-model="modalDescription"
            type="text"
            label="Description"
          />

          <div class="tw-flex tw-items-center tw-shrink-0 tw-mb-2.5 tw-gap-2">
            <CustomToggle v-model="modalBreakingChange" />
            <span class="tw-text-font-neutral-900 tw-font-bold tw-text-base">
              Breaking Change
            </span>
          </div>

          <div class="tw-flex tw-items-center tw-gap-4 tw-justify-end tw-w-full">
            <DefaultButton
              variant="primary-inverted"
              :loading="isPending"
              :disabled="isPending"
              @click="mutate(false)"
            >
              Save Changes
            </DefaultButton>

            <DefaultButton
              :loading="isPending"
              :disabled="isPending"
              @click="mutate(true)"
            >
              Approve and Publish
            </DefaultButton>

            <DefaultButton
              variant="danger"
              :loading="isPending"
              :disabled="isPending"
              @click="closeEditModal"
            >
              Cancel
            </DefaultButton>
          </div>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>
